// extracted by mini-css-extract-plugin
export default {"footer":"MapModal_footer__oKeDs","btnSet":"MapModal_btnSet__5KXp4"};